import React from 'react'
import Sheet from '@amzn/meridian/sheet'
import ProfileSettingsPage from './index'
import './ProfileSettingsPage.scss'

interface IProfileSettingsSheetProps {
    open: boolean
    onClose: () => void
}

/**
 * Bottom sheet wrapper for the Profile & Settings page.
 * Follows the exact same pattern as NotificationsSheet.
 */
export const ProfileSettingsSheet: React.FC<IProfileSettingsSheetProps> = ({ open, onClose }) => {
    return (
        <Sheet
            type="overlay"
            side="bottom"
            open={open}
            onClose={onClose}
            spacingInset="none"
            data-atb-id="profile-settings-sheet"
            // Meridian puts `className` on the outer container it positions and `data-*` on the
            // inner div, so only this class can carry the stacking override below.
            className="profile-settings-sheet"
            motionDuration={0}
        >
            <div className="profile-settings-sheet-content">
                <ProfileSettingsPage onClose={onClose} />
            </div>
        </Sheet>
    )
}
